module.exports = __webpack_public_path__ + "img/sClaFruit7_350x350.21ea1029.jpg";